(function(){
'use strict';

/*
  BGC 2026 cart authority reset.
  Retina's native cart code is the owner of add-to-cart, cart contents,
  quantity/remove controls, and drawer rendering. Seal owns selling plans.
  Bundler owns bundle discounts. This file only removes retired BGC cart UI.
*/
if(window.__BGC_CART_AUTHORITY_RESET_2026__)return;
window.__BGC_CART_AUTHORITY_RESET_2026__=1;

function cleanup(){
  ['.bgc-cart-purchase','.bgc-fullcart-purchase','.bgc-fixed-drawer-actions','.bgc-cart-sub-toggle'].forEach(function(selector){
    Array.prototype.slice.call(document.querySelectorAll(selector)).forEach(function(node){
      if(node&&node.parentNode)node.parentNode.removeChild(node);
    });
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',cleanup,{once:true});else cleanup();
document.addEventListener('shopify:section:load',cleanup);
window.addEventListener('pageshow',cleanup);
})();

(function(){
'use strict';

/*
  BGC Plan B — Stage 1 v2, desktop homepage only.
  Retina 4.7.4's native AJAX quick-add is allowed to finish normally, but its
  automatic cart-drawer presentation is immediately suppressed after a coffee
  quick-add. A real header-cart click always cancels suppression and opens the
  native drawer normally. No global browser APIs are monkey-patched.
*/
if(window.__BGC_PLAN_B_STAGE1_V2_2026__)return;
window.__BGC_PLAN_B_STAGE1_V2_2026__=1;

var DESKTOP='(min-width:768px)';
var suppressUntil=0;
var closeTimer=0;
var observer=null;

function active(){
  return isDesktopHome() && Date.now()<suppressUntil;
}
function isDesktopHome(){
  return !!(window.matchMedia&&window.matchMedia(DESKTOP).matches&&document.body&&document.body.classList.contains('index'));
}
function closest(target,selector){
  return target&&target.closest?target.closest(selector):null;
}
function isQuickAdd(target){
  return !!closest(target,'.bgc-coffee-showcase .bgc-quick-add .ajax-submit');
}
function isHeaderCart(target){
  return !!closest(target,'.cart-button, a[href="#cart"], .top-link-cart');
}
function nativeClose(){
  if(!active())return;
  var cart=document.getElementById('cart');
  if(!cart)return;

  if(window.jQuery){
    var $cart=window.jQuery(cart);
    try{$cart.trigger('close.mm');}catch(e){}
    var api=$cart.data('mmenu');
    if(api&&typeof api.close==='function'){
      try{api.close();}catch(e){}
    }
  }

  var html=document.documentElement;
  if(html&&html.classList.contains('mm-opened')){
    var close=cart.querySelector('.mm-close, .cart-close, .close, [data-close-menu]');
    if(close&&typeof close.click==='function'){
      try{close.click();}catch(e){}
    }
  }
  if(window.location.hash==='#cart'){
    try{history.replaceState(null,document.title,window.location.pathname+window.location.search);}catch(e){}
  }
}
function scheduleClose(){
  if(!active())return;
  clearTimeout(closeTimer);
  nativeClose();
  closeTimer=setTimeout(nativeClose,0);
  setTimeout(nativeClose,60);
  setTimeout(nativeClose,180);
}
function beginSuppression(){
  suppressUntil=Date.now()+4000;
  scheduleClose();
}
function clearSuppression(){
  suppressUntil=0;
  clearTimeout(closeTimer);
}

document.addEventListener('click',function(event){
  if(!isDesktopHome())return;
  if(isHeaderCart(event.target)){
    if(event.isTrusted!==false)clearSuppression();
    else if(active()){
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    return;
  }
  if(isQuickAdd(event.target)&&event.isTrusted!==false)beginSuppression();
},true);

function bindMmenu(){
  if(!window.jQuery)return;
  var $cart=window.jQuery('#cart');
  if(!$cart.length||$cart.data('bgcPlanBStage1V2Bound'))return;
  $cart.data('bgcPlanBStage1V2Bound',true);
  $cart.on('opening.mm.bgcPlanB open.mm.bgcPlanB opened.mm.bgcPlanB',function(){
    if(active())setTimeout(nativeClose,0);
  });
}

function observeDrawerState(){
  if(observer||!window.MutationObserver)return;
  var html=document.documentElement;
  if(!html)return;
  observer=new MutationObserver(function(){
    if(active()&&html.classList.contains('mm-opened'))scheduleClose();
  });
  observer.observe(html,{attributes:true,attributeFilter:['class']});
}

function initialize(){
  bindMmenu();
  observeDrawerState();
  var tries=0;
  var timer=setInterval(function(){
    bindMmenu();
    tries+=1;
    if(tries>=40||(window.jQuery&&window.jQuery('#cart').length))clearInterval(timer);
  },100);
}

window.addEventListener('hashchange',function(){
  if(active()&&window.location.hash==='#cart')scheduleClose();
});
window.addEventListener('pageshow',function(){clearSuppression();bindMmenu();});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
})();

(function(){
'use strict';

/* BGC Plan B — Stage 1.1: reserve desktop homepage scrollbar space so Retina's brief scroll lock cannot shift the page width. */
if(window.__BGC_PLAN_B_SCROLLBAR_GUTTER_2026__)return;
window.__BGC_PLAN_B_SCROLLBAR_GUTTER_2026__=1;

function stabilize(){
  if(!document.body||!document.body.classList.contains('index'))return;
  if(!window.matchMedia||!window.matchMedia('(min-width:768px)').matches)return;
  document.documentElement.style.scrollbarGutter='stable';
}
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',stabilize,{once:true});
}else{
  stabilize();
}
})();

(function(){
'use strict';

/* BGC Plan B — Stage 2: desktop cart acknowledgement. Visual only; mirrors the proven mobile pulse. */
if(window.__BGC_DESKTOP_CART_PULSE_2026__)return;
window.__BGC_DESKTOP_CART_PULSE_2026__=1;

var DESKTOP='(min-width:768px)';
var observer=null,observedHeader=null,lastCount=null,lastPulseCount=null,lastPulseAt=0,pulseTimer=0;
function desktop(){return !!(window.matchMedia&&window.matchMedia(DESKTOP).matches);}
function q(s,r){return (r||document).querySelector(s);}
function cartButton(){return q('#trewq .nav.mobile_hidden .cart-button:not(.no-js-only)');}
function cartCount(){var b=cartButton(),c=b&&q('.cart_count',b);if(!c)return 0;var n=parseInt(String(c.textContent||'').replace(/[^0-9-]/g,''),10);return isFinite(n)&&n>=0?n:0;}
function addCss(){
  if(q('#bgc-desktop-cart-pulse-css'))return;
  var s=document.createElement('style');s.id='bgc-desktop-cart-pulse-css';
  s.textContent='@media(min-width:768px){'+
  '@keyframes bgcDesktopCartIconPop2026{0%,100%{transform:scale(1)}28%{transform:scale(1.18)}52%{transform:scale(.97)}76%{transform:scale(1.08)}}'+
  '@keyframes bgcDesktopCartCountPop2026{0%,100%{transform:scale(1)}26%{transform:scale(1.30)}52%{transform:scale(.96)}76%{transform:scale(1.10)}}'+
  '#trewq .nav.mobile_hidden .cart-button:not(.no-js-only){box-shadow:0 2px 8px rgba(91,55,13,.16),inset 0 1px 0 rgba(255,255,255,.22)!important;transition:box-shadow .18s ease!important}'+
  '#trewq .nav.mobile_hidden .cart-button:not(.no-js-only) .cart_count{box-sizing:border-box!important;min-width:20px!important;height:20px!important;line-height:20px!important;padding:0 5px!important;border-radius:999px!important;background:#A8342F!important;color:#fff!important;text-align:center!important;font-weight:700!important;box-shadow:0 0 0 2px rgba(230,183,92,.36),0 2px 6px rgba(80,36,20,.22)!important;text-shadow:0 1px 1px rgba(0,0,0,.14)!important}'+
  '#trewq .nav.mobile_hidden .cart-button:not(.no-js-only).bgc-cart-pop:before{transform-origin:center center!important;animation:bgcDesktopCartIconPop2026 .78s cubic-bezier(.2,.75,.3,1) both!important;text-shadow:0 0 7px rgba(217,155,50,.75),0 0 12px rgba(168,52,47,.30)!important}'+
  '#trewq .nav.mobile_hidden .cart-button:not(.no-js-only).bgc-cart-pop .cart_count{transform-origin:center center!important;animation:bgcDesktopCartCountPop2026 .82s cubic-bezier(.2,.75,.3,1) both!important;box-shadow:0 0 0 3px rgba(217,155,50,.42),0 0 14px rgba(168,52,47,.34)!important}'+
  '#trewq .nav.mobile_hidden .cart-button:not(.no-js-only).bgc-cart-pop{box-shadow:0 0 0 2px rgba(217,155,50,.20),0 0 16px rgba(217,155,50,.30),0 3px 9px rgba(91,55,13,.16)!important}'+
  '}@media(min-width:768px) and (prefers-reduced-motion:reduce){#trewq .nav.mobile_hidden .cart-button:not(.no-js-only).bgc-cart-pop:before,#trewq .nav.mobile_hidden .cart-button:not(.no-js-only).bgc-cart-pop .cart_count{animation:none!important}}';
  document.head.appendChild(s);
}
function pulse(n){
  if(!desktop())return;var b=cartButton();if(!b)return;var now=Date.now();
  if(lastPulseCount===n&&now-lastPulseAt<1200)return;
  lastPulseCount=n;lastPulseAt=now;clearTimeout(pulseTimer);b.classList.remove('bgc-cart-pop');void b.offsetWidth;b.classList.add('bgc-cart-pop');
  pulseTimer=setTimeout(function(){b.classList.remove('bgc-cart-pop');},860);
}
function note(n){
  n=parseInt(n,10);if(!isFinite(n)||n<0)return;
  if(lastCount===null){lastCount=n;return;}
  if(n>lastCount)pulse(n);
  lastCount=n;
}
function inspect(){note(cartCount());}
function bindObserver(reset){
  if(!desktop())return;addCss();var h=q('#trewq');if(!h)return;
  if(reset||lastCount===null)lastCount=cartCount();
  if(h===observedHeader&&observer)return;
  if(observer)observer.disconnect();observedHeader=h;
  observer=new MutationObserver(function(){inspect();});
  observer.observe(h,{childList:true,subtree:true,characterData:true});
}
function init(){
  if(!desktop()){if(observer)observer.disconnect();observer=null;observedHeader=null;lastCount=null;return;}
  bindObserver(true);
}
document.addEventListener('cart:updated',function(e){if(!desktop())return;var c=e.detail&&e.detail.cart;if(c&&typeof c.item_count==='number')note(c.item_count);else inspect();});
document.addEventListener('shopify:section:load',function(){bindObserver(true);});
window.addEventListener('pageshow',function(){bindObserver(true);});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

(function(){
'use strict';

/* BGC Plan B — Stage 2.1: desktop cart luxury polish. CSS only; no cart behavior changes. */
if(window.__BGC_DESKTOP_CART_LUXURY_2026__)return;
window.__BGC_DESKTOP_CART_LUXURY_2026__=1;
function addLuxuryCss(){
  if(document.getElementById('bgc-desktop-cart-luxury-css'))return;
  var s=document.createElement('style');
  s.id='bgc-desktop-cart-luxury-css';
  s.textContent='@media(min-width:768px){'+
  '#trewq .nav.mobile_hidden .cart-button:not(.no-js-only){background-image:linear-gradient(145deg,rgba(255,255,255,.20) 0%,rgba(255,255,255,.06) 34%,rgba(107,63,10,.10) 100%)!important;background-clip:padding-box!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.42),inset 0 -1px 0 rgba(90,48,8,.16),0 3px 9px rgba(91,55,13,.18),0 0 0 1px rgba(255,220,145,.16)!important}'+
  '#trewq .nav.mobile_hidden .cart-button:not(.no-js-only) .cart_count{background:linear-gradient(145deg,#C34E48 0%,#A8342F 58%,#84251F 100%)!important;box-shadow:inset 0 1px 1px rgba(255,255,255,.42),0 0 0 2px rgba(230,183,92,.44),0 2px 7px rgba(80,36,20,.26)!important}'+
  '#trewq .nav.mobile_hidden .cart-button:not(.no-js-only).bgc-cart-pop{box-shadow:inset 0 1px 0 rgba(255,255,255,.44),0 0 0 2px rgba(217,155,50,.20),0 0 16px rgba(217,155,50,.30),0 3px 9px rgba(91,55,13,.16)!important}'+
  '#trewq .nav.mobile_hidden .cart-button:not(.no-js-only).bgc-cart-pop .cart_count{box-shadow:inset 0 1px 1px rgba(255,255,255,.46),0 0 0 3px rgba(217,155,50,.42),0 0 14px rgba(168,52,47,.34)!important}'+
  '}';
  document.head.appendChild(s);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',addLuxuryCss,{once:true});else addLuxuryCss();
})();

(function(){
'use strict';

/* BGC Plan B — Stage 2.2: stronger whole-button acknowledgement. CSS only; reuses existing bgc-cart-pop event. */
if(window.__BGC_DESKTOP_CART_WHOLE_GLOW_2026__)return;
window.__BGC_DESKTOP_CART_WHOLE_GLOW_2026__=1;
function addWholeGlowCss(){
  if(document.getElementById('bgc-desktop-cart-whole-glow-css'))return;
  var s=document.createElement('style');
  s.id='bgc-desktop-cart-whole-glow-css';
  s.textContent='@media(min-width:768px){'+
  '@keyframes bgcDesktopCartButtonHeroPop2026{0%,100%{transform:scale(1)}24%{transform:scale(1.09)}48%{transform:scale(.985)}72%{transform:scale(1.04)}}'+
  '#trewq .nav.mobile_hidden .cart-button:not(.no-js-only){transform-origin:center center!important;will-change:auto}'+
  '#trewq .nav.mobile_hidden .cart-button:not(.no-js-only).bgc-cart-pop{animation:bgcDesktopCartButtonHeroPop2026 .82s cubic-bezier(.2,.75,.3,1) both!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.48),0 0 0 3px rgba(238,182,58,.34),0 0 18px rgba(238,182,58,.58),0 0 30px rgba(168,52,47,.24),0 5px 13px rgba(91,55,13,.24)!important}'+
  '#trewq .nav.mobile_hidden .cart-button:not(.no-js-only).bgc-cart-pop:before{filter:drop-shadow(0 0 3px rgba(255,236,170,.95)) drop-shadow(0 0 7px rgba(218,155,50,.82))!important;text-shadow:0 0 9px rgba(245,196,82,.92),0 0 16px rgba(168,52,47,.34)!important}'+
  '}@media(min-width:768px) and (prefers-reduced-motion:reduce){#trewq .nav.mobile_hidden .cart-button:not(.no-js-only).bgc-cart-pop{animation:none!important;transform:none!important}}';
  document.head.appendChild(s);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',addWholeGlowCss,{once:true});else addWholeGlowCss();
})();

(function(){
'use strict';

/* BGC desktop cart direction repair — lightweight: set right-side intent once, then let Retina/mmenu own the animation. */
if(window.__BGC_DESKTOP_CART_RIGHT_REPAIR_2026__)return;
window.__BGC_DESKTOP_CART_RIGHT_REPAIR_2026__=1;

var intentUntil=0;
var bindTimer=0;

function desktopHome(){
  return !!(window.matchMedia&&window.matchMedia('(min-width:768px)').matches&&document.body&&document.body.classList.contains('index'));
}
function cartButton(target){
  return target&&target.closest?target.closest('#trewq .nav.mobile_hidden .cart-button:not(.no-js-only), #trewq .nav.mobile_hidden a[href="#cart"].cart-button'):null;
}
function intentActive(){return desktopHome()&&Date.now()<intentUntil;}
function enforceRight(){
  if(!intentActive())return;
  var html=document.documentElement;
  var cart=document.getElementById('cart');
  if(!html||!cart)return;
  if(cart.classList){cart.classList.remove('mm-left');cart.classList.add('mm-right');}
  if(html.classList){html.classList.remove('mm-left');html.classList.add('mm-right');}
}
function beginIntent(){
  intentUntil=Date.now()+2500;
  enforceRight();
}

document.addEventListener('click',function(event){
  if(!desktopHome()||event.isTrusted===false)return;
  if(cartButton(event.target))beginIntent();
},true);

function bindMmenu(){
  if(!desktopHome()||!window.jQuery)return;
  var $cart=window.jQuery('#cart');
  if(!$cart.length||$cart.data('bgcCartRightRepairBound'))return;
  $cart.data('bgcCartRightRepairBound',true);
  $cart.on('opening.mm.bgcCartRightRepair',function(){
    if(intentActive())enforceRight();
  });
}
function initialize(){
  bindMmenu();
  var tries=0;
  bindTimer=setInterval(function(){
    bindMmenu();
    tries+=1;
    if(tries>=30||(window.jQuery&&window.jQuery('#cart').length))clearInterval(bindTimer);
  },100);
}
window.addEventListener('pageshow',function(){intentUntil=0;bindMmenu();});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
})();
